module.exports = __webpack_public_path__ + "img/product-tiyanke-js-01.1f334a37.png";